<script setup lang="ts">
  import { computed, ref, watch, defineEmits, nextTick  } from 'vue';
  import { useI18n } from '@/hooks/web/useI18n';
  
  const { t } = useI18n()
  const props = defineProps({
    modelValue: { type:Array },
    type:{ type:String, default:'string'}
  })
  const _value = ref<any>([])
  const onAdd = ()=>{
      if(!props.modelValue) return
      _value.value.push({
        value1:null,
        value2:null,
        operator1:'<',
        operator2:'<=',
        mapval:'',
        color:'',
      })
      emit('update:modelValue', _value.value) 
  }
  const onDelete = (item,index)=>{
      if(!props.modelValue) return
      _value.value.splice(index,1)
      emit('update:modelValue', _value.value)
  }
  // const onChangeColor = ()=>{
  //   emit('update:modelValue', _value.value)
  // }

  const emit = defineEmits(['update:modelValue']);
  watch(()=>props.modelValue, (val:any) => {
    try{
      if(val){
        _value.value = [...val]
      }
    }catch(error){}
  }, 
  {
    immediate: true,
    deep: true
  })

</script>

<template>
  <Collapse :title="'映射'" expand class="val-map">
    <template #rtSlot>
      <el-icon
        v-if="modelValue"
        @click="onAdd"
        style="font-size:16px;color:var(--c-primary)"
        class="ml-6px cursor-pointer">
        <Plus />
      </el-icon>
    </template>
    <el-form v-if="modelValue" size="small" class="flex flex-col gap-8px"> 
      <template v-if="type=='number'">
        <div
          v-for="th,index in modelValue"
          :key="index"
          class="flex items-center gap-4px">
          <el-input-number v-model="th.value1" controls-position="right" style="width:100px"/>
          <el-select v-model="th.operator1" style="width:60px" :teleported="false">
            <el-option label="<" value="<" />
            <el-option label="<=" value="<=" />
            <el-option label="==" value="==" />
          </el-select>
          <span class="w-30px text-15px text-center">值</span>
          <el-select v-model="th.operator2" size="small" style="width:60px" :teleported="false">
            <el-option label="<" value="<" />
            <el-option label="<=" value="<=" />
            <el-option label="==" value="==" />
          </el-select>
          <el-input-number v-model="th.value2" controls-position="right" style="width:100px"/>
          <el-input v-model="th.mapval" style="width:100px"/>
          <color-picker v-model="th.color" size="small" :teleported="false" show-alpha />
          <el-icon
            @click="onDelete(th,index)"
            style="font-size:16px;cursor:pointer">
            <Close />
          </el-icon>
        </div>
      </template>
      <template v-else-if="type=='string'">
        <div
          v-for="th,index in modelValue"
          :key="index"
          class="flex items-center gap-4px">
          <span class="text-15px text-center">关键字</span>
          <el-input v-model="th.value1" size="small" style="width:120px"/>
          <span class="text-15px text-center">映射值</span>
          <el-input v-model="th.value2" size="small" style="width:120px"/>          
          <color-picker v-model="th.color" size="small" :teleported="false" show-alpha />
          <el-icon
            @click="onDelete(th,index)"
            style="font-size:16px;cursor:pointer">
            <Close />
          </el-icon>
        </div>
      </template>      
    </el-form>
  </Collapse>
</template>
<style lang="less" scoped>
.colors{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap:10px;
  &-icon{
    cursor: pointer;
    color: #89898A;
  }
  &-title{
    color: var(--text-on_subtle-general-primary, #323233);
    font-size: var(--font_size-16, 16px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--font_size-24, 24px);
  }
  &-lft, &-rt{
    display: flex;
    align-items: center;
    gap:8px; 
  }
}
</style>